
<div class="scroll-container" #scrollContainer [ngClass]="{'show': showScroll, 'showPlane': showScrollPlane}" [ngStyle]="{'height': height+'px'}">
  <button
		*ngIf="showScroll || showScrollPlane"
		class="scroll-button up"
		[ngStyle]="{'left': offsetWidth+'px'}"
		[ngClass]="{'active': activeUp, 'themeLight': themeLightScroll, 'activeLight': themeLightScroll && activeUp}"
		(click)="scroll(-100)"
	>
  <img src="../../../../assets/images/up-scroll.svg" alt="up">
  </button>
  <ng-content></ng-content>
  <button
		*ngIf="showScroll || showScrollPlane"
		class="scroll-button down"
		[ngStyle]="{'left': offsetWidth+'px', 'top': offsetTopButtonDown+'px'}"
		[ngClass]="{'active': activeDown, 'themeLight': themeLightScroll, 'activeLight': themeLightScroll && activeDown }"
		(click)="scroll(100)"
	>
	<img src="../../../../assets/images/down-scroll.svg" alt="down">
  </button>
</div>
